var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecTypeOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55 18.6498L2 15.0998L3.05 14.0498L5.55 16.5248L10.025 12.0498L11.075 13.1248L5.55 18.6498ZM5.55 10.6498L2 7.0998L3.05 6.0498L5.55 8.5248L10.025 4.0498L11.075 5.1248L5.55 10.6498ZM13 16.7498V15.2498H22V16.7498H13ZM13 8.7498V7.2498H22V8.7498H13Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecTypeOptions);
export default __webpack_public_path__ + "static/media/spec-type-options.1ba167d4b1de244b672391edcbff522e.svg";
export { ForwardRef as ReactComponent };